{
  "familyId": "SWW-BN-VD-DUBBEL",
  "questions": [
    {
      "id": "SWW-BN-VD-DUBBEL-001",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'de ... jongen' (redden → als bijvoeglijk naamwoord)?",
      "context": null,
      "options": ["geredde", "gerede", "geredden", "gereden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Korte Klinker → Dubbel", "content": "Bij een korte klinker verdubbel je de medeklinker: gered (korte e) → geredde (dubbel d).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_short_vowel_double",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord bij korte klinker. Stap 1: Het voltooid deelwoord van 'redden' is 'gered' (ge + red + d, maar dubbele d wordt enkel). Stap 2: 'Gered' heeft een korte 'e'. Stap 3: Bij een korte klinker verdubbel je de medeklinker om de korte klank te behouden: gered + de = geredde (dubbel d). Checkstrategie: hoor je een korte klank? Dan medeklinker verdubbelen. Vergelijk: 'gerede' zou klinken als 'ge-ree-de' (lange e) — dat is fout.",
        "distractorExplanations": {
          "0": "Correct! Korte klinker → medeklinker verdubbelen: gered + de = geredde (dubbel d).",
          "1": "Veelgemaakte fout: de medeklinker niet verdubbelen bij een korte klinker. 'Gerede' zou klinken als 'ge-ree-de' (lange e). De korte 'e' in 'gered' vereist een dubbele d: geredde. Misconceptie: de klinkerlengte niet herkennen.",
          "2": "Veelgemaakte fout: -en gebruiken in plaats van -e. Bijvoeglijke naamwoorden krijgen -e (niet -en): de geredde jongen (niet geredden). Misconceptie: bijvoeglijk naamwoord verwarren met meervoudsvorm.",
          "3": "Veelgemaakte fout: werkwoorden verwarren. 'Gereden' is het voltooid deelwoord van 'rijden' (niet van 'redden'). Redden → gered → geredde."
        }
      }
    },
    {
      "id": "SWW-BN-VD-DUBBEL-002",
      "familyId": "SWW-BN-VD-DUBBEL",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_medeklinker_verd",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": null,
      "options": ["De gezette man liep langzaam.", "De gezete man liep langzaam.", "De gezetten man liep langzaam.", "De gezetde man liep langzaam."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Korte Klinker → Dubbel", "content": "Bij een korte klinker verdubbel je de medeklinker: gezet (korte e) → gezette (dubbel t).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "adjective_short_vowel_gezet",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: bijvoeglijk naamwoord bij korte klinker. Stap 1: Het voltooid deelwoord van 'zetten' is 'gezet' (ge + zet + t, maar de stam eindigt op t → geen dubbele t). Stap 2: 'Gezet' heeft een korte 'e'. Stap 3: Bij een korte klinker verdubbel je de medeklinker: gezet + te = gezette (dubbel t). Checkstrategie: hoor je een korte klank? Dan medeklinker verdubbelen.",
        "distractorExplanations": {
          "0": "Correct! Korte klinker → medeklinker verdubbelen: gezet + te = gezette (dubbel t).",
          "1": "Veelgemaakte fout: de medeklinker niet verdubbelen bij een korte klinker. 'Gezete' zou klinken als 'ge-zee-te' (lange e). De korte 'e' in 'gezet' vereist een dubbele t: gezette. Misconceptie: de klinkerlengte niet herkennen.",
          "2": "Veelgemaakte fout: -en gebruiken in plaats van -e. Bijvoeglijke naamwoorden krijgen -e (niet -en): de gezette man (niet gezetten). Misconceptie: bijvoeglijk naamwoord verwarren met meervoudsvorm.",
          "3": "Veelgemaakte fout: -de toevoegen aan een stam die op t eindigt. Het voltooid deelwoord is 'gezet' (niet 'gezetd'). Als bijvoeglijk naamwoord: gezet + te = gezette (dubbel t bij korte klinker)."
        }
      }
    }
  ]
}